import { I18N } from "oc-I18N";
import { Auswahl, AuswahlAccessor } from "./Auswahl";
import { GehflügelBreitenEingabe } from "./GehflügelBreitenEingabe";
import { StandflügelBreitenEingabe } from "./StandflügelBreitenEingabe";
import { findAuswahl, getDreifachtorPartnerElement } from "../arrangement/elementFunctions";
import { ZElement } from "../arrangement/ZElement";
import { Zusatzartikel } from "./zauneditor/Zusatzartikel";

export const ausrichtungCode = (tor: ZElement) => {
  if (tor.isSchiebetor) {
    const motorseite =
      tor.schiebetormotorseiteAuswahlwert?.Key === "Schiebetormotorseite_A" ? "a" : "b";
    const schieberichtung =
      tor.schieberichtungAuswahlwert?.Key === "Schieberichtung_links" ? "l" : "r";
    return "s" + motorseite + schieberichtung;
  }

  let code = "";
  let aufhängungCode;
  if (tor.isDreifachtor) {
    const dreifachEinzeltor = tor.isEinzeltor ? tor : getDreifachtorPartnerElement(tor);
    tor = tor.isDoppeltor ? tor : getDreifachtorPartnerElement(tor);
    code = "3" + (dreifachEinzeltor.isDreifachtorEinzeltorLinks ? "l" : "r");
    aufhängungCode = tor.gehflügelAuswahlwert.Key == "Gehflügel_links" ? "l" : "r";
  } else {
    code = tor.isDoppeltor ? "d" : "e";
    aufhängungCode = (tor.isDoppeltor ? tor.isGehflügelLinks : !tor.isAufhängungAnLinkerTorseite)
      ? "r"
      : "l";
  }

  const isHolzzaun = tor.meta.Aufbautyp.Key == "Kein_Zuschnitt_Holzzaun";
  const isÖffnungNachInnen = tor.öffnungAuswahlwert?.Key == "Öffnung_nach_innen";
  const isFlippedNormal = tor.segment?.flippedNormal;

  return (
    code +
    (isÖffnungNachInnen ? "i" : "a") +
    (isFlippedNormal ? (aufhängungCode == "l" ? "r" : "l") : aufhängungCode) +
    (isHolzzaun
      ? isÖffnungNachInnen == tor.isAufhängungAnLinkerTorseite
        ? "b"
        : "a"
      : tor.füllungsseiteAuswahlwert?.Key == "Füllungsseite_A"
        ? "a"
        : "b")
  );
};

export function TorEigenschaften({ tor }: { tor: ZElement }) {
  const showProfilleisteAuswahl = tor?.profilKategorieAuswahlwert?.Key == "KeramikProfile";
  const eAntriebAuswahl = findAuswahl("E_Antrieb_Zubehör");
  const schiebetorAuswahl = findAuswahl("Schiebetor_Zubehör");
  const zubehörAuswahl = tor.isSchiebetor ? schiebetorAuswahl ?? eAntriebAuswahl : eAntriebAuswahl;
  const zubehör = tor.zubehörAnzahl;

  const isZubehörKeyValid = tor.isSchiebetor
    ? (key: string) => !key.includes("Bodenverriegelung")
    : undefined;

  return (
    <div
      role="region"
      className="eigenschaften-gruppe"
      aria-label={I18N("aria::Tor-Eigenschaften")}
    >
      {tor.isDoppeltor && (
        <>
          <AuswahlAccessor accessorKey="Gehflügel" />
          <StandflügelBreitenEingabe tor={tor} />
          <GehflügelBreitenEingabe tor={tor} />
        </>
      )}

      <AuswahlAccessor accessorKey="Rahmen" />
      {tor.isDoppeltor && !tor.anMauer && <AuswahlAccessor accessorKey="E_Antrieb_Vorhanden" />}
      {!tor.isSchiebetor && <AuswahlAccessor accessorKey="Öffnung" />}
      {!tor.isDoppeltor && !tor.isSchiebetor && <AuswahlAccessor accessorKey="Anschlag" />}
      {tor.isSchiebetor && <AuswahlAccessor accessorKey="Schiebetormotorseite" />}
      {tor.isSchiebetor && <AuswahlAccessor accessorKey="Schieberichtung" />}
      {<AuswahlAccessor accessorKey="Füllungsseite" />}

      <div className="ausrichtung_image_container">
        <div className={`image ausrichtung_image ausrichtung_${ausrichtungCode(tor)}`}>
          <div>{tor.isSchiebetor ? I18N("Seite 1") : I18N("innen")}</div>
          <div>{tor.isSchiebetor ? I18N("Seite 2") : I18N("außen")}</div>
        </div>
      </div>

      {showProfilleisteAuswahl && <AuswahlAccessor accessorKey="Profilleiste" />}
      <AuswahlAccessor accessorKey="Drücker" />
      <AuswahlAccessor accessorKey="Toröffner" />
      <AuswahlAccessor accessorKey="Torschließer" />
      <AuswahlAccessor accessorKey="Profilzylinder" />

      {tor.hasAnschlagprofil && (
        <Auswahl
          Key="Anschlagprofil"
          title={I18N("Anschlagprofil")}
          value={tor.anschlagprofilAuswahlwert}
          onChange={(v) => {
            tor.anschlagprofilAuswahlwert = v;
            APP.dirty();
          }}
        />
      )}

      {(tor.isEAntrieb || tor.isSchiebetor) && zubehörAuswahl && (
        <Zusatzartikel auswahl={zubehörAuswahl} zubehör={zubehör} isKeyValid={isZubehörKeyValid} />
      )}
    </div>
  );
}
